export const servicePaginationData = {
  page: 1,
  limit: 100,
  isActive: true,
};
